import {Container, Text, Wrap} from "./styled";
import {SectionTitle} from "../../CummonComponents/SectionTitle/SectionTitle";
import {PricingTable} from "../PricingPlans/PricingPlans";

export const WeOffer = ({data}) => {
    if (!data) {
        return null;
    }

    const parseContactInfo = (text) => {
        const emailMatch = text.match(/([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/);
        const phoneMatch = text.match(/(\+?\d[\d\s()]+)/);

        let result = text;
        if (emailMatch) {
            result = result.replace(emailMatch[0], `<a href="mailto:${emailMatch[0]}">${emailMatch[0]}</a>`);
        }
        if (phoneMatch) {
            result = result.replace(phoneMatch[0], `<a href="tel:${phoneMatch[0].replace(/\s/g, '')}">${phoneMatch[0]}</a>`);
        }
        return result;
    };


    return (
        <Container>
            <Wrap>
                <Text line={'after'} dangerouslySetInnerHTML={{ __html: data.content_description?.replace(/\n/g, '<br/>') || '' }} />
                <SectionTitle>{data.content_title}</SectionTitle>
                <PricingTable plans={data?.subscribes_list || []}/>
                <Text
                    line={'before'}
                    dangerouslySetInnerHTML={{ __html: parseContactInfo(data.content_footer?.replace(/\n/g, '<br/>') || '') }}
                />
            </Wrap>
        </Container>
    )
}
